import { Container } from './styles';

import type { CSSProperties, ReactNode } from 'react';

export interface CardProps {
  className?: string;
  style?: CSSProperties;
  verticalAlign?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  horizontalAlign?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  children?: ReactNode;
  maxWidth?: string;
  width?: string | number;
  padding?: string;
  borderRadius?: string;
  sx?: CSSProperties;
}

function Card({
  className,
  style,
  verticalAlign = 'flex-start',
  horizontalAlign = 'flex-start',
  children,
  width,
  maxWidth,
  padding,
  borderRadius,
  sx,
}: CardProps) {
  return (
    <Container
      className={className}
      style={style}
      verticalAlign={verticalAlign}
      horizontalAlign={horizontalAlign}
      width={width || undefined}
      maxWidth={maxWidth || undefined}
      padding={padding || undefined}
      borderRadius={borderRadius || undefined}
      sx={sx}
    >
      {children}
    </Container>
  );
}

export default Card;
